import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from 'recompose';
import HeaderNews from '../Header';
import { StyledArticleColumn1 } from '../../style';
import ParseHtml from '../../../../core/ParseHTML';
import AuxDiv from '../../../../core/AuxDiv';

const TemplateMultimediaCenter = ({ body, ...props }) => (
  <AuxDiv>
    <HeaderNews {...props} />
    <StyledArticleColumn1>
      <ParseHtml html={body} />
    </StyledArticleColumn1>
  </AuxDiv>
);

TemplateMultimediaCenter.propTypes = {
  body: PropTypes.string
};
export default compose(pure)(TemplateMultimediaCenter);
